import { IconBookmark, IconChevronDown } from '@tabler/icons-react';
import {
  ActionIcon,
  Button,
  Group,
  Menu,
  useMantineTheme,
} from '@mantine/core';

interface SplitButtonProps {
  color?: string;
  disabled?: boolean;
  c?: string;
  buttonText: string;
  handleSubmission: (autoSubmit: boolean) => Promise<void>;
  count: number;
  isLoading: boolean;
  eSubmission?: boolean;
}

export const SubmitSplitButton = ({
  color,
  c,
  buttonText,
  handleSubmission,
  count,
  isLoading,
  disabled = false,
  eSubmission = false,
}: SplitButtonProps) => {
  const theme = useMantineTheme();
  return (
    <Group wrap="nowrap" gap={0}>
      <Button
        color={color}
        disabled={disabled}
        loading={isLoading}
        loaderProps={{ type: 'dots' }}
        c={c}
        style={{ borderTopRightRadius: 2, borderBottomRightRadius: 2 }}
        onClick={() => {
          handleSubmission(eSubmission);
        }}
      >
        {`${buttonText} (${count})`}
      </Button>
      <Menu
        transitionProps={{ transition: 'pop' }}
        position="bottom-end"
        withinPortal
        disabled={disabled}
      >
        <Menu.Target>
          <ActionIcon
            variant="outline"
            color={color}
            disabled={disabled}
            c={c}
            size={36}
            style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}
          >
            <IconChevronDown size={16} stroke={1.5} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={
              <IconBookmark
                size={16}
                stroke={1.5}
                color={theme.colors.blue[5]}
              />
            }
            onClick={() => {
              handleSubmission(false);
            }}
          >
            Save
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
